module.exports = __webpack_public_path__ + "static/media/holiday3.08ed0306.webp";